var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _path, _path2, _g11, _g12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptystate2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 942 887",
    width: 942,
    height: 887,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7117865_3371470-ai") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n\t\t.s0 { fill: #f5f5f5 } \r\n\t\t.s1 { fill: #e0e0e0 } \r\n\t\t.s2 { fill: #f0f0f0 } \r\n\t\t.s3 { fill: #fafafa } \r\n\t\t.s4 { fill: #ffffff } \r\n\t\t.s5 { fill: #ebebeb } \r\n\t\t.s6 { fill: none;stroke: #27debf;stroke-width: 1.8 } \r\n\t\t.s7 { fill: none;stroke: #27debf;stroke-linecap: round;stroke-linejoin: round;stroke-width: 1.8 } \r\n\t\t.s8 { fill: #263238 } \r\n\t\t.s9 { fill: #37474f } \r\n\t\t.s10 { fill: #455a64 } \r\n\t\t.s11 { fill: none;stroke: #fafafa;stroke-width: 1.5 } \r\n\t\t.s12 { opacity: .2;fill: #000000 } \r\n\t\t.s13 { fill: none;stroke: #fafafa;stroke-linecap: round;stroke-linejoin: round;stroke-width: 1.5 } \r\n\t\t.s14 { opacity: .1;fill: #000000 } \r\n\t\t.s15 { fill: #27debf } \r\n\t\t.s16 { opacity: .5;fill: #000000 } \r\n\t\t.s17 { opacity: .4;fill: #000000 } \r\n\t\t.s18 { opacity: .3;fill: #000000 } \r\n\t\t.s19 { opacity: .7;fill: #ffffff } \r\n\t\t.s20 { fill: #ffa8a7 } \r\n\t\t.s21 { fill: #f28f8f } \r\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Floor"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Floor 7 ",
    className: "s0",
    d: "m803.2 422.4c183.8 106.1 183.8 278.1 0 384.2-183.7 106.1-481.7 106.1-665.5 0-183.8-106.1-183.7-278.1 0-384.2 183.8-106.1 481.8-106.1 665.5 0z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Shadow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shadow 29 ",
    className: "s1",
    d: "m875.2 616.2c52.1 30.1 52.1 78.9 0 109-52.2 30.1-136.7 30.1-188.8 0-52.2-30.1-52.2-78.9 0-109 52.1-30.1 136.6-30.1 188.8 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shadow 28 ",
    className: "s1",
    d: "m442.9 712.3l-150.6-87 172.1-99.4 150.7 87z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shadow 27 ",
    className: "s1",
    d: "m195.7 591.3l194.3 112.2-162.9 94-194.3-112.1z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Shelf"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shelf 2 "
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shelf"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m320 158.3c0 1-0.7 2.1-2.2 2.9l-191.6 109.9c-2.8 1.7-7.4 1.7-10.2 0l-66.6-38.2c-1.5-0.8-2.2-1.9-2.2-2.9h-0.1v-11.1h0.1c0-1 0.7-2.1 2.2-2.9l191.5-110c2.9-1.6 7.5-1.6 10.3 0l66.6 38.3c1.5 0.8 2.2 1.9 2.2 2.9v11.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m49.4 216l191.5-110c2.9-1.6 7.5-1.6 10.3 0l66.6 38.3c2.8 1.6 2.8 4.2 0 5.9l-191.6 109.9c-2.8 1.6-7.4 1.6-10.2 0l-66.6-38.2c-2.9-1.7-2.9-4.3 0-5.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m121.1 261.3v11.1c-1.8 0-3.7-0.5-5.1-1.3l-66.6-38.2c-1.5-0.8-2.2-1.9-2.2-2.9h-0.1v-11.1h0.1c0-0.4 0.1-0.8 0.4-1.2-0.8 1.4-0.2 3 1.8 4.2l66.6 38.2c1.4 0.8 3.3 1.2 5.1 1.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Book 2 "
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m250.2 114.5l56.5 32.2-93.3 53.5-56.5-32.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m214 197.8l-54.4-31.3q2.1-6-0.3-14.1l54.1 30.9c0 0 1 3.5 0.6 14.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m210.6 178.9c2.9 1.7 5.2 5.7 5.2 9v10.6c0 3.3-2.3 4.6-5.2 3l-53.7-30.8v-2.6l53 30.2c1.7 1 3.1 0.1 3.1-1.8v-9.8c0-2-1.4-4.4-3.2-5.4l-52.9-30.2v-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m156.9 148.1l93.3-53.5 53.7 30.8c2.9 1.7 5.2 5.7 5.2 9v10.5c0 1.7-0.6 2.9-1.5 3.4l-93.3 53.5c0.9-0.5 1.5-1.7 1.5-3.3v-10.6c0-3.3-2.3-7.3-5.2-9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m307.6 129.3c0.9 1.6 1.5 3.5 1.5 5.1v10.5c0 1.7-0.6 2.9-1.5 3.4l-93.3 53.5c0.9-0.5 1.5-1.7 1.5-3.3v-10.6c0-1.6-0.5-3.5-1.5-5.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Book 1 "
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m163.4 124.7l-1.4 4.2-63-33.8 0.5-7.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m153.2 133.7l-62.3-36.4 10.6-6.2 61.1 35.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m148.8 134l2.5 1.5c0.6 0.3 1.2 0.5 1.9 0.5l22 89.6c-0.7 0-1.3-0.2-1.8-0.5l-35.5-20.5c-1.2-0.7-2.2-2.5-2.2-3.9l6-70.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m155.9 135.5l6.3-5.4 4.6-4c0.5-0.7 1.1-1.3 0.8-1.9l21.7 88.9v0.1c0.3 0.6 0.4 2-0.5 2.5l-10.9 9.4c-0.7 0.4-1.8 0.6-2.7 0.5l-22-89.6c0.9 0.1 1.9-0.1 2.7-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m166.8 123.5c1.3 0.7 1 1.5 0 2.6l-10.9 9.4c-1.3 0.7-3.3 0.7-4.5 0l-9.7-5.6c-1.2-0.7-1.5-1.7-0.5-2.3 1-0.6 2.8-0.4 4.1 0.3l7.6 4.4c0.4 0.2 1.1 0.2 1.5 0l8-7c0.4-0.2 0.4-0.6 0-0.8l-62.9-36.5 3-1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Book"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m81.3 91.4l60.1 34.7v114.2l-60.1-34.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m125.7 135.1l-57.7-33.2q8.8-2.1 13.3-7.3l58.1 33.4c-10 6.2-13.7 7.1-13.7 7.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m62.8 102l2.7-1.6 56.4 32.5c1.8 1.1 4.8 1.1 6.7 0l9.1-5.1c1.8-1.1 1.8-2.8 0-3.9l-56.4-32.5 2.4-1.4 57.3 32.9c3.1 1.7 3.1 4.6 0 6.4l-9.8 5.6c-3 1.8-8 1.8-11.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m120.1 134.9c3.1 1.8 8.1 1.8 11.1 0l9.8-5.6c1.6-0.9 2.3-2.1 2.3-3.2v114.2c0 1.2-0.7 2.4-2.3 3.2l-9.8 5.7c-3 1.7-8 1.7-11.1 0l-57.3-32.9v-114.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m125.7 136.2c2 0 4-0.4 5.5-1.3l9.8-5.6c1.6-0.9 2.3-2.1 2.3-3.2v114.2c0 1.2-0.7 2.4-2.3 3.2l-9.8 5.7c-1.5 0.8-3.5 1.3-5.5 1.3z"
  })))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Plants"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Plants 5 "
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m609 550.9c-1.3-24-12-71.9 2-116.2 7.1-22.5 23.5-46.4 47.8-53.1 8.6-2.4 19.2-2 23.4 7.8 0.7 1.6 1.1 3.4 1.3 5.2 0.5 7.4-2.9 14-6.7 20.1-8.6 13.9-19.5 26.3-28.2 40.1-4.7 7.3-8.6 15-12.1 23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m608.4 554.2c1.7-22 8-43.8 19.1-63 8.2-14.4 18.6-27.1 33.6-35.3 7.4-4 16.4-6.9 23-7.4 7-0.5 14.4 0.9 19.9 5.2 5.5 4.4 8.5 12.1 6.2 18.7-1.5 4.4-5.2 7.7-8.8 10.7-12.3 10-26.3 17.9-38.9 27.5-11.6 9-22 19.4-30.9 31.1-4.5 5.9-8.7 12.1-12.4 18.5q-2.7 4.7-5.1 9.5c-0.7 1.6-1.7 3.3-2.3 4.9-0.3 0.8-0.7 3.9-1.2 4.3-0.6 0.6-1.7 0.2-2-0.6-0.4-0.8-0.2-1.7 0-2.5 0.6-2.7-0.2-6.4-0.2-9.2q0-6.2 0-12.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m694.3 460.5c-28.5 8.2-70.7 40.8-85.9 101.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m665 394.6c-15.3 12.2-52 50.9-56.7 113.6"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Bookshelf"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bookshelf 2 "
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m611.3 276v304.3c0 2.7-0.9 4.6-2.5 5.5-1.4 0.9-6.6 3.9-8 4.7-1.5 0.9-3.7 0.8-6-0.6l-111.2-64.1c-4.8-2.7-8.6-9.4-8.6-14.8v-304.4c0-2.7 1-4.6 2.5-5.5 1.5-0.8 6.6-3.8 8-4.6 1.6-0.9 3.7-0.8 6.1 0.6l111.2 64.1c4.7 2.7 8.5 9.3 8.5 14.8z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m515.1 525.5l-7.2 20.8c-0.5 1.3-1.8 2.9-3 3.6l-3.7 2.1c-1.2 0.7-3.1 0.7-4.3 0l-3.7-2.1c-1.2-0.7-2.2-2.4-2.2-3.7v-25.4l8.1-4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m491 520.8l16.1 9.3-7.2 20.8c-0.5 1.3-1.8 1.8-3 1.1l-3.7-2.1c-1.2-0.7-2.2-2.4-2.2-3.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m595.3 571.7l-7.2 20.8c-0.5 1.3-1.8 2.9-3 3.6l-3.7 2.1c-1.2 0.7-3.1 0.7-4.3 0l-3.7-2.1c-1.2-0.7-2.2-2.4-2.2-3.8v-25.3l8-4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m571.2 567l16.1 9.3-7.2 20.8c-0.5 1.3-1.8 1.8-3 1.1l-3.7-2.1c-1.2-0.7-2.2-2.4-2.2-3.8z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m484.1 201.9l111.2 64.1c4.7 2.7 8.6 9.3 8.6 14.8v304.3c0 2.7-1 4.6-2.5 5.5-1.6 0.9-3.7 0.8-6.1-0.6l-111.2-64.1c-4.7-2.7-8.5-9.3-8.5-14.8v-304.3c0-2.8 0.9-4.7 2.5-5.6 1.5-0.8 3.7-0.7 6 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Bottom 1 "
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m322.6 608.7l160.4-92.6 120.3 69.5 8 4.6-168.4 97.2-120.3-69.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m442.9 687.4v-9.3l168.4-97.2v9.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m443.1 673.5c22.5-34 21.2-94.2 19.3-104.3 0 0 9.5 63.6 21.2 81.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m466.4 592.3c3.9 18.5 47.7 31.6 47.7 31.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m476.3 605.7c-5-2.5-5.7 6.5-5.7 6.5-1.2-4.9-7.3-4.5-8.5-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m488.7 613.5c-13.6-6.2-14.1 14.4-14.1 14.4-3.7-11.5-12-8.8-14.3-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m504.2 620.5c-14.5-6.4-26.5 6.8-26.6 17.2-3.3-8.4-16.4-4.8-21.1 4.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m448.4 664.1c5.6-10.1 19.3-28.4 31.2-21.1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m595.3 488.3v9.3l-152.4 88-120.3-69.5v-9.3l152.4-87.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m595.3 488.3l-152.4 88-120.3-69.5 152.4-87.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m595.3 386.5v9.2l-152.4 88-120.3-69.5v-9.2l152.4-88z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m595.3 386.5l-152.4 87.9-120.3-69.4 152.4-88z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Side 1 "
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m451 368.5v304.3c0 2.7-1 4.6-2.5 5.5-1.5 0.9-6.6 3.8-8.1 4.7-1.5 0.9-3.7 0.7-6-0.6l-111.2-64.1c-4.7-2.8-8.6-9.4-8.6-14.8v-304.4c0-2.7 1-4.6 2.5-5.5 1.5-0.8 6.6-3.8 8.1-4.6 1.5-0.9 3.6-0.8 6 0.6l111.2 64.1c4.7 2.7 8.6 9.3 8.6 14.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m442.9 372.6l8.1-4.7v27.8l-8.1 4.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m603.3 280l8.1-4.6v27.8l-8.1 4.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m354.7 618l-7.2 20.8c-0.4 1.3-1.8 2.9-2.9 3.5l-3.8 2.2c-1.2 0.7-3.1 0.7-4.3 0l-3.7-2.2c-1.2-0.6-2.1-2.3-2.1-3.7v-25.3l8-4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m330.7 613.3l16 9.3-7.2 20.8c-0.5 1.3-1.8 1.8-3 1.1l-3.7-2.2c-1.2-0.6-2.1-2.3-2.1-3.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m434.9 664.2l-7.2 20.8c-0.5 1.3-1.8 2.9-2.9 3.5l-3.8 2.2c-1.2 0.7-3.1 0.7-4.3 0l-3.7-2.2c-1.2-0.6-2.1-2.3-2.1-3.7l-0.1-25.3 8.1-4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m410.8 659.5l16.1 9.3-7.2 20.8c-0.5 1.3-1.8 1.8-3 1.1l-3.7-2.2c-1.2-0.6-2.1-2.3-2.1-3.7z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m323.2 294.2l111.2 64.1c4.7 2.7 8.5 9.4 8.5 14.8v304.3c0 2.8 0 10 0 10 0 0-6.2-3.7-8.5-5l-111.2-64.1c-4.7-2.8-8.6-9.4-8.6-14.8v-304.4c0-2.7 1-4.6 2.5-5.5 1.6-0.9 3.7-0.8 6.1 0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m442.9 373.1v27.3l-128.3-74.1v-27.2c0-2.7 1-4.6 2.5-5.5 1.6-0.9 3.7-0.8 6.1 0.6l111.2 64.1c4.7 2.7 8.5 9.4 8.5 14.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s13",
    d: "m499.1 344.8l88.2-50.9v92.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s13",
    d: "m555.2 349.4l32.1-55.5-16.1 69.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s13",
    d: "m587.3 293.9l-48.1 46.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s13",
    d: "m587.3 371.7c0-13-14.8-13.7-14.8-13.7 0.9-3.9-0.1-10.3-4.9-14.3-4.8-4.1-8-1.9-9-0.2 0 0 1-11.9-9.3-13.1 0 0 6.8-12.6 0-14.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s13",
    d: "m587.3 351.7c-0.6-6.6-5.6-15-10.9-11 0 0 1.4-14.5-8.9-12.6 0 0 4.8-13.4-5.3-10.1 0 0 7.3-9.2 1.6-10.6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Top 1 "
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m630.3 270.7c0.1 1.8-1.1 3.6-3.5 5l-183.3 105.8c-4.8 2.8-12.4 2.8-17.1 0l-119.3-68.8c-2.3-1.4-3.5-3.1-3.5-4.9 0-1.7 0-7.6 0-9.3 0-1.8 1.2-3.6 3.5-4.9l183.4-105.9c4.7-2.7 12.4-2.7 17.1 0l119.2 68.8c2.4 1.4 3.6 3.2 3.5 5 0 1.6 0 7.6 0 9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m426.4 372.3l-119.3-68.8c-4.7-2.8-4.7-7.2 0-9.9l183.4-105.9c4.7-2.7 12.4-2.7 17.1 0l119.2 68.8c4.8 2.8 4.8 7.2 0 9.9l-183.3 105.9c-4.8 2.7-12.4 2.7-17.1 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shadows 1 "
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m603.3 289.2l-56.1 69.5-96.2 55.6-0.1-37.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m595.3 395.7l-48.1 64.8-96.2 55.6v-37z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m595.3 497.6l-48.1 64.8-96.2 55.6v-37.1z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Box"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Box 2 "
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s15",
    d: "m374.6 699.9l-147.6 85.2-166.1-96.2 147.5-85.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s16",
    d: "m374.6 699.9l-147.6 85.2-166.1-96.2 147.5-85.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s15",
    d: "m208.4 488.3v115.5l-147.5 85.1v-115.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m208.4 488.3v115.5l-147.5 85.1v-115.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s15",
    d: "m227 669.6v115.5l-166.1-96.2v-115.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s17",
    d: "m227 669.6v115.5l-166.1-96.2v-115.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s15",
    d: "m374.6 584.4v115.5l-166.2-96.1v-115.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s17",
    d: "m374.6 584.4v115.5l-166.2-96.1v-115.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s15",
    d: "m227 785.1v-115.5l147.6-85.2v115.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m227 785.1v-115.5l147.6-85.2v115.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s15",
    d: "m208.4 488.3l0.2-63.9 165.8 96.2 0.2 63.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m208.4 488.3l0.2-63.9 165.8 96.2 0.2 63.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s15",
    d: "m227 669.6l13.9-55.9 146.2-84.4-12.5 55.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s18",
    d: "m227 669.6l13.9-55.9 146.2-84.4-12.5 55.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s15",
    d: "m60.9 573.5l-17.6-58 147.5-85.2 17.6 58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m60.9 573.5l-17.6-58 147.5-85.2 17.6 58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s15",
    d: "m60.9 573.5l-34.7-48 166.1 96.2 34.7 47.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s16",
    d: "m60.9 573.5l-34.7-48 166.1 96.2 34.7 47.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.7
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m270.5 750.7c-0.5 0-0.9-0.4-0.9-0.9v-20.3c0-0.5 0.4-0.9 0.9-0.9 0.5 0 0.9 0.4 0.9 0.9v20.3c0 0.5-0.4 0.9-0.9 0.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m267.8 736.5q-0.2 0-0.3 0c-0.5-0.2-0.7-0.8-0.5-1.2l3.2-7.5 3.6 4.2c0.3 0.3 0.3 0.9-0.1 1.2-0.4 0.4-0.9 0.3-1.3 0l-1.7-2-2 4.8c-0.2 0.3-0.5 0.5-0.9 0.5z"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m278.9 745.9c-0.5 0-0.9-0.4-0.9-0.9v-20.3c0-0.5 0.4-0.9 0.9-0.9 0.5 0 0.9 0.4 0.9 0.9v20.3c0 0.5-0.4 0.9-0.9 0.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m276.2 731.8q-0.2 0-0.4-0.1c-0.4-0.2-0.6-0.8-0.4-1.2l3.2-7.5 3.6 4.2c0.3 0.4 0.3 0.9-0.1 1.3-0.4 0.3-0.9 0.3-1.3-0.1l-1.7-2-2.1 4.8c-0.1 0.3-0.4 0.6-0.8 0.6z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.7
    }
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m246.3 764.5q-0.5 0-1-0.3c-0.7-0.3-1.1-1.1-1.1-2.1v-2.5c0-0.5 0.4-0.9 0.9-0.9 0.5 0 0.9 0.4 0.9 0.9v2.5c0 0.3 0.1 0.5 0.2 0.6 0.1 0 0.3 0 0.6-0.2 0.8-0.4 1.7-2.2 1.7-4.1v-10.4c0-0.5 0.4-0.9 0.9-0.9 0.5 0 0.9 0.4 0.9 0.9v10.4c0 2.4-1.1 4.8-2.6 5.7q-0.7 0.4-1.4 0.4z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s4",
    d: "m236.8 756.1v-1.5c0-7.4 5.2-16.4 11.5-20.1 3.3-1.9 6.4-2.2 8.8-0.8 2.4 1.4 3.8 4.2 3.8 8v0.5zm17-21.5c-1.4 0-2.9 0.5-4.5 1.4-5.5 3.2-10 10.5-10.6 16.9l20.3-11.7c-0.1-2.9-1.1-5-2.8-6q-1.1-0.6-2.4-0.6z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m26.2 525.5l166.1 96.2 34.7 47.9-36.5-46.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m229.8 671.9l-2.8 113.2v-115.5l147.6-85.2z"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Moth"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Moth 2 "
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m157.9 537.4c3.1-1 6.1-2.1 9.1-3.4 12.4-5.4 23-14.2 29.8-25.9 3.1-5.4 5.5-11.4 6.6-17.7 1-5.6 1.4-11.7-0.5-17.2-3.3-9.3-12.9-14.2-22.3-14.9-4.9-0.4-10 0.3-14.6 2.2-4.8 2-8.7 5.4-11.6 9.8-1.3 1.9-3.2 5-2.5 7.5 0.6 2.5 4.2 1.6 6 1 6.9-2.5 11.6-8.3 15.3-14.4 3.3-5.5 6.3-11.6 7.2-18.1 0.9-6.3 0.1-12.9-1.7-19-1.8-5.8-4.8-11.6-9.8-15.4-5.3-4-12.1-5.7-18.6-6-6.4-0.3-13.2 0.5-19 3.1-2.4 1.1-4.9 2.3-6.5 4.3-0.6 0.8-1.6 2.3-1.2 3.6 0.4 1.1 1.7 1.6 2.7 1.7 3.4 0.2 6.9-2.3 9.3-4.4 2.9-2.6 5.3-6 7.3-9.3 2.9-4.8 3.2-10.5 0.4-15.5-2.7-4.9-7.4-8.6-12.4-11-5.1-2.6-11-4.3-16.8-3.9-0.8 0.1-1.5-1.5-0.4-1.6q4.5-0.3 9 0.6c11 2.3 25 10.5 25.2 23.2 0.1 3.1-0.8 6-2.2 8.7-2 3.6-4.6 7.1-7.6 10-2.6 2.6-6.2 4.9-10 5.4-2.6 0.3-6.3-0.6-7.1-3.4-0.7-2.6 1.3-5.3 3-6.9 2.3-2.1 5.3-3.5 8.3-4.5 6.8-2.4 14.3-3 21.5-2.1 7 1 14.3 3.5 19.4 8.6 4.9 4.9 7.7 11.8 9.1 18.4 1.4 6.6 1.8 13.7 0 20.1-2.1 7.6-6.3 15-11.1 21q-3.6 4.5-8.6 7.3c-2.6 1.5-6 2.9-9.1 2.3-2.6-0.4-4.6-2.3-4.5-5.1 0.1-3.1 1.9-6.1 3.7-8.6 3.4-4.7 7.9-8.2 13.4-10.1 5.2-1.8 10.8-2.3 16.2-1.6 10.7 1.4 20.9 7.9 23.6 18.9 1.7 6.4 0.7 13.4-0.9 19.7-1.7 6.9-4.9 13.3-9 19.1-8.8 12.4-22.7 22.1-37.9 24.3-0.4 0.1-0.5-0.7-0.2-0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s15",
    d: "m98.6 348.4c9.9-3 5 12.9 5 12.9 6.8-0.6 11.9 2.8 7.1 6.4-4.8 3.5-10 1.2-10 1.2 3.4 5.7-1.1 14.6-4.6 13.5-3.4-1-2.4-10.3-2.4-10.3 0 0-10.4 7.4-14.3 2.8-3.9-4.6 7-10.9 15.1-10.3-2.5-8.9-0.8-14.7 4.1-16.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m98.6 348.4c9.9-3 5 12.9 5 12.9 6.8-0.6 11.9 2.8 7.1 6.4-4.8 3.5-10 1.2-10 1.2 3.4 5.7-1.1 14.6-4.6 13.5-3.4-1-2.4-10.3-2.4-10.3 0 0-10.4 7.4-14.3 2.8-3.9-4.6 7-10.9 15.1-10.3-2.5-8.9-0.8-14.7 4.1-16.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m103.2 371.3c-0.1 0.1-0.3 0.1-0.4 0.1-1.2-0.5-2.3-1.3-3.4-2.1-0.7-0.5-1.4-1-2.1-1.5-0.6-0.5-1.3-1-2-1.4q-0.6-0.3-1.1-0.6c-0.7-0.4-1.5-0.5-2.1-1.3-0.5-0.7 0.1-1.5 0.8-1.6 0.7-0.1 1.3 0 2 0.3q0.7 0.3 1.4 0.7 1.1 0.6 2.1 1.3 1.1 0.8 2.1 1.6 0.8 0.5 1.4 1.2c0.6 0.6 2.1 2.5 1.3 3.3z"
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Character 7 "
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s20",
    d: "m776 133c0 0-15.3 99.5-21.8 118.5-5.3 15.2-6.9 30.3-22.2 28.7-22-2.2-71.6-7.1-81-7.1-4.3 0-8.8-0.8-13.2 0.6-2.9 0.9-5.5 2.5-8.2 3.9-6.9 3.8-14.3 6.6-22 8.4-0.8 0.2-1.8 0.4-2.5-0.1-0.8-0.5-1-1.7-0.8-2.6 0.4-2.6 2.7-4.5 5-5.9 1.4-0.9 7.1-4.2 5.2-6.3-1.3-1.4-4.7-0.6-6.3-0.5-3.9 0-7.7 0.5-11.5 1.3-16.7 3.8-21.1 1-21.9-5.1-0.7-5.4-2-25.8 29.2-29.9 12.6-1.6 38.3 0.8 50.2 2.1 10.8 1.1 39.2 2.1 60.5 2.7 4.4-20.7 16.1-85.4 24.9-97.1 10.4-14 21-13.8 36.4-11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m765.2 228.8c-36.5 4.8-48.1-12-48.1-12 0 0 7-27.4 10.9-42.7 4-15.3 6.2-25.9 15.2-36 9.1-10.1 25.7-8 33-6.7z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s20",
    d: "m867.9 660.3h-25.7l-7.3-55.7 32.3-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s20",
    d: "m782.7 632.5c-4.4 7.5-18.4 6.9-30.1 4.2l-1.3-54.7 34.3-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s15",
    d: "m866.2 308.3c0.9 23.7-2.3 163.9-2.3 163.9 0.9 6.8 7.9 18.6 9.4 43.2 2.1 35.5-5.1 111.7-5.1 111.7 0 0-14.7 7.6-30.6 1.8 0 0-16.1-110.1-21.9-145.2-5.1-30.6-11.6-112.7-11.6-112.7l-12.7 105.2c0 0 3.6 16.7 2.9 37.8-0.5 16.4-9.9 95.8-9.9 95.8 0 0-15.6 5.9-32.8 0.8 0 0-7.6-123.3-8.5-138.2-1-17.1-0.3-167.5-0.3-167.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m792.7 465.9l1.1-91.8c-20.3-10.9-27.4-23.1-27.4-23.1 15.3 13.7 37.7 20 37.7 20z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m873.7 663c0 0 2.1 6.8 0.4 11.7-0.8 2.3-4.7 7.1-7 11.2-2.6 4.6-1.7 10.1-2.1 15.9-0.3 5.8-3 10-8.8 14-5.8 4-14.8 5.8-24.9 5.4-10.6-0.3-16.7-5.1-17.7-6.6-1-1.5-1.5-7-0.7-7.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m838.4 648.7c0.1-1.2 0.2-1.9 0.8-2.7 0.5-0.7 1.4-1.2 2.3-1.5 2.9-0.7 6.4-0.5 9.4-0.3 3.3 0.3 6.5 0.9 9.7 1.9 0.9 0.2 1.9 0.6 2.5 1.2 0.4 0.4 0.6 1.6 0.5 2.2-0.3 2-0.3 3.1-1.2 5.7 2-1.8 2-4.6 3.9-6.5 1.5-1.6 1.4-1.8 1.4-4 1.5-0.5 3 4.3 4.3 8.5 1.5 4.8 3.3 10.2 1.5 15.2-1.1 2.8-2.8 5.3-4.5 7.8-2.8 4.3-5.2 9-5.6 14.1-0.2 2.2 0.1 4.4-0.2 6.7-1 7.7-6.3 13.8-13.9 16.3-6.8 2.3-14.4 2.9-21.5 2-6.6-1-15.4-3.3-15.2-11.3 0-4.7 2.6-9 5.7-12.6 3.1-3.6 6.8-6.8 9.7-10.5 1.5-2 2.8-4 4-6.1 2.3-4.1 4.4-8.4 5.7-12.9 0.6-2.2 0.9-4.3 0.9-6.5 0-2.1-0.2-5.4-0.2-6.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m834 671.1c0 0 2.5-1.6 11.4-1.4 5.4 0.2 9.5 2.3 11.8 3.9 1.1 0.8 1.3 2.3 0.3 3.3-0.7 0.9-2 1-3 0.4-2.1-1.5-5.9-2.9-10.4-3.2-3.6-0.3-10.2 0-13.1 2.4-1-2.6 3-5.4 3-5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m828.7 679.9c0 0 2.2-1.9 11.2-1.6 5.4 0.2 9.7 2.6 12 4.2 1.1 0.8 1.3 2.3 0.3 3.3-0.8 0.9-2 1-3 0.4-2.1-1.5-5.6-3.1-10.1-3.4-3.7-0.3-11-0.3-14.6 2.1 0.5-3.4 4.2-5 4.2-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m860.2 664.6c0.9 0.5 1.3 1.6 0.9 2.6-0.5 1.1-1.8 1.5-2.9 1-0.8-0.4-1.8-0.9-2.5-1.2-3.1-1.2-6.8-2.2-9.8-2.2-4.3-0.1-7.9 0.5-9.8 1.7-1.1-0.6-0.1-3.1 1.4-4 2.4-1 5-1.8 11.2-1.4 4.9 0.3 9.3 2.3 11.5 3.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m789.1 653.3c0 0 1.5 6-0.2 9.3-1.8 3.3-11.5 6.5-18.8 6.5-7.3 0.1-13.1 0.5-18.9 4-5.8 3.4-16.1 8.8-30.9 9.1-14.7 0.3-25.3-6.3-26.2-8.5-0.9-2.1-1-5.4 0-7.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m764 627.5c0.4 0.3 0.7 0.6 0.9 1.1 0.1 0.4-0.1 0.9-0.2 1.3-0.2 0.6-1.8 6.1-1.7 6.1 3 0.8 6.4 1.6 9.2 0.3 1.7-0.8 3-2.1 4.3-3.4q1.4-1.6 2.9-3.1c0.8-0.8 3.3-1.9 3.6-3l0.2-3.6c3.2-0.1 2.5 10.7 4.2 18 1.5 6.6 3.4 14.3 1.6 16.6-4.8 5.2-18.4 6.5-25.5 6.8-11.2 0.3-21.1 8.9-29.7 10.9-15.8 3.7-30.5-0.6-36.1-4.2-6.3-4.1-5.1-13.8 0.8-17.5 4.1-2.4 10.9-3.5 16-5.5 5.1-2 9.9-3.8 14.8-6.1 7.2-3.5 13.9-7.4 17.2-12.2 1.3-2 2.4-4.1 4-5.7 0.5-0.6 1.2-1 1.9-1.2 0.6-0.1 1.3 0.1 1.9 0.2q0.6 0.2 1.2 0.3c3.1 0.9 5.9 1.9 8.5 3.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m736.1 638.6c0 0 1.2-2.7 5.4-3.3 3.3-0.4 8.9 2.2 12.3 5.3 1.4 1.3 1.1 3.6-0.6 4.4-1 0.5-2.2 0.3-3-0.5-2.3-2.1-7.3-6-14.1-5.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m725.8 643.7c0 0 2.3-3.1 6.4-2.9 0 0 8.4 0.7 13.4 5.8 1.3 1.3 1.1 3.4-0.6 4.2-0.9 0.5-2.1 0.3-2.9-0.5-2.2-2.2-6.7-6.8-16.3-6.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m714.5 648.3c0 0 2.5-2.9 6.6-2.6 0 0 7.9 0.7 12.9 5.8 1.2 1.3 1 3.4-0.6 4.2-1 0.5-2.1 0.3-2.9-0.5-2.3-2.2-6.4-7.2-16-6.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m819 131.9c9.5 1.1 20.6 1.6 29.6 2.8 11.7 1.5 20.7 13.6 23.6 32.2 3.1 20.4-10 79.2-10 79.2l4.2 69.2c-17 12.5-89.5 19.1-125.6-7 0 0 0.8-117.8 3.6-135.9 3.9-24.9 10-40.3 38.1-42.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s20",
    d: "m899.2 253.8l-43.2-60.2c-18.6-23.1-7.4-58.9-7.4-58.9 29.7 2.9 35.2 23.6 46.8 40.6 11.7 17 45.9 65.4 45.7 71.8-0.3 6.3-1.7 12.5-12.7 27.6 0 0-19.5 30.5-30.9 44.1-8 9.4-25.5 28.9-37 35.1-28.6 15.4-39.8-2.5-42.4-7.4-3-5.6-1-10.6 15.2-17.4 3.7-1.5 7.1-3.5 10.4-5.8 1.6-1.1 7-3.8 4.2-6.1-0.9-0.7-2-0.9-3.1-1q-3.9-0.5-7.8-1c-1.7-0.2-3.5-0.4-4.9-1.4-1.4-1-2.2-3-1.3-4.5 0.8-1.2 2.5-1.5 4-1.7q13.5-1.5 27.1-2c1.8 0 5 0.6 6.5-0.4 0.6-0.5 1.8-1.8 2.3-2.4q1.8-2.8 3.5-5.6c3.2-5.1 6.3-10.2 9.3-15.3 4.2-7 15.7-28.1 15.7-28.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m900 219.3c-12.4 9.1-22.8 9.4-22.8 9.4l-17-23c0 0-14.1-11.8-17.9-28.5-4.5-19.8-2.8-39.6 0.2-44.2 33.9 0.4 31.9 6.7 55.4 41 5.6 8.2 11.4 16.4 16.9 24.4 0 0-2.3 11.7-14.8 20.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m839.1 75.3h0.1c0 0-7.3 24.6-10 29.7-2.9 5.6-7.6 5.8-7.6 5.8l-0.5-17.7 2.8-15.8 1.7-43c0 0 9.3-1.5 15.7 7.4 3.1 4.4 4.5 13.5-2.2 33.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s20",
    d: "m821.9 77.5c0.8-2.7 1.6-4.2 4.1-6.9 2.5-2.6 12.3-5.5 16.7 2.9 4.6 8.4-3 19.3-8.8 22.6-7.4 4.3-11.8-1.5-11.8-1.5l0.2 39.5c-3.5 7.9-19.1 15.1-28.4 13.9-7.4-0.9-14.2-6.7-7.6-15.2l-0.5-11.3c0 0-9.9 2-14.8 1.5-8.2-0.8-13.6-7-16.5-15.6-4.6-13.9-6.7-25.2-4.7-53 2.1-30.5 37.4-32.6 57.1-21.5 19.6 11 15 44.6 15 44.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m738.6 22.8c-0.9-6.7 1.4-13.8 8.3-16.2 5.3-1.8 10.7-1.7 15.5 2.6 1.7-4.7 6.3-8.2 11.3-8.8 4.9-0.5 10.1 2 12.8 6.3 2.1-3 4.6-4.8 8-5.6 4-1 9 0 11.9 2.1 2.8 2.1 6.2 6.1 5.3 11.1 5.7-2.3 11.5-0.4 15.7 4.6 2.5 3 3.9 6.8 4 10.7 0 1.9-0.1 4.2-0.9 6-0.8 1.8-2.4 3-2.9 5-0.4 2-1.3 3.8-1.1 5.7 0.5 3.4 1.2 6.7 1.7 10.1 0.4 3.3 0.8 6.6 0.8 9.9 0 1.5-1.1 2.6-2.4 3.8-2.2 1.9-2.6 2.9-4.2 6.1-0.7 1.4-1.4 5-2.8 6-4.3 2.9-4.7-6.7-4.9-8.6-0.2-1.8-0.3-6.6 0-12.8-1.3-0.1-6.9-0.2-11.3-5.2-1.4-1.6-2.5-4.1-2.8-6.3-0.2-1.3-0.4-2.5-0.3-3.9-2.8 4.6-9.3 6.5-13.9 6.1-7.7-0.7-10.4-4-11.6-6.4-0.6 2.1-1.5 4.9-3.1 6.5-1.9 2-4.6 3.2-6.9 4-4.3 1.5-9.4-0.4-12.6-3.6-3.2 4.5-11.1 2.5-12.9 1.2-4-2.9-5.3-6.4-5.7-11.3-0.5-5 1.5-10.6 7-12.5-1-2-1.7-4.3-2-6.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s21",
    d: "m785.8 121.5c0 0 17.8-4.5 24-8.2 4.1-2.4 7.4-6.5 8.3-9.1 0 0-0.9 5.5-4.5 10.5-4.3 6.1-27.6 11.6-27.6 11.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m790.4 71.9c2.2-0.1 4 1.6 4.1 3.9 0.1 2.2-1.5 4.1-3.7 4.2-2.1 0.1-3.9-1.6-4-3.8-0.2-2.3 1.5-4.2 3.6-4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s21",
    d: "m785.5 99.6c2.8-0.1 5.1 2.1 5.2 5 0.2 2.8-1.9 5.3-4.7 5.4-2.7 0.2-5.1-2-5.2-4.9-0.2-2.9 2-5.3 4.7-5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m796 60.6c2.3 1.1 3.3 3.9 2.2 6.3l-8.2-4.1c1.1-2.3 3.8-3.3 6-2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m754.8 59.6c1.9-1.6 4.8-1.3 6.4 0.7l-7.1 6c-1.6-2-1.3-5 0.7-6.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m759.8 71.3c2.1-0.1 3.8 1.5 3.9 3.7 0.1 2.1-1.4 4-3.5 4.1-2.1 0.1-3.9-1.6-4-3.7-0.1-2.2 1.5-4 3.6-4.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s21",
    d: "m774.8 70.9l-0.1 23.7-12.5-3.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m742.7 103.9l-10.9-7.2c-0.4-0.3-0.6-0.9-0.3-1.3 0.3-0.5 0.9-0.6 1.3-0.3l10.9 7.3c0.4 0.2 0.5 0.8 0.2 1.2q-0.2 0.4-0.5 0.4-0.4 0.1-0.7-0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m741.8 108.7l-12.7-2.9c-0.5-0.2-0.8-0.7-0.7-1.2 0.1-0.5 0.6-0.8 1.1-0.6l12.7 2.9c0.5 0.1 0.8 0.6 0.7 1.1-0.1 0.4-0.3 0.6-0.7 0.7q-0.2 0.1-0.4 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m729.3 116.6c-0.1-0.5 0.1-1 0.6-1.2l12.2-4.5c0.5-0.2 1.1 0.1 1.2 0.6 0.2 0.4 0 1-0.5 1.2l-12.3 4.4q0 0.1-0.1 0.1c-0.4 0.1-0.9-0.2-1.1-0.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m626.5 210.8l9.2-22.5c0.5-1.5 2.2-2.2 3.7-1.7 1.5 0.5 2.3 2.2 1.7 3.7l-9.1 22.5c-0.6 1.5-2.2 2.3-3.7 1.7-0.7-0.2-1.3-0.7-1.6-1.4-0.4-0.7-0.4-1.5-0.2-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m611.4 211.8l-0.3-28c0-1.6 1.2-2.9 2.8-3 1.6 0 2.9 1.3 3 2.9l0.3 28.1c0 1.6-1.3 2.9-2.9 2.9-1.2 0-2.2-0.7-2.6-1.6q-0.3-0.6-0.3-1.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m587.2 193.7c1.3-0.8 3.1-0.5 4 0.8l13.8 20c0.8 1.3 0.5 3.2-0.8 4.1-1.3 0.8-3.1 0.5-4-0.8l-13.8-20q-0.1-0.2-0.2-0.4c-0.6-1.2-0.2-2.8 1-3.7z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptystate2);
export default __webpack_public_path__ + "static/media/emptystate2.99df0cfcd523fb60a2ba1da544bf2019.svg";
export { ForwardRef as ReactComponent };